import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const gapCursorPluginKey = new PluginKey('gapCursorPlugin');
